export class IntegrationProductFlags {
  carousels: boolean;
  liveSessions: boolean;
  polls: boolean;
  sceneBuilder: boolean;
  constructor(attrs?: Partial<IntegrationProductFlags>) {
    this.carousels = attrs?.carousels ?? true;
    this.liveSessions = attrs?.liveSessions ?? true;
    this.polls = attrs?.polls ?? false;
    this.sceneBuilder = attrs?.sceneBuilder ?? false;
  }
}
